module.exports = __webpack_public_path__ + "img/xxjy.6114e4aa.png";